<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uV6hCg/tc-custom/9780061995477.jpg?1718079115739" alt="This image is the cover for the book Psychic"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Psychic
      </h1>
      <p class="bookDescription body article font2">
        <p>“I have known Sylvia for twenty years, and I have the greatest respect for her. People seek her out for her much celebrated intuitive skills, however, I have sought her out for her friendship and kindness. I applaud her for the peace and solace that she has brought to so many.” — Montel Williams </p><p>“An amazing woman, an amazing life, and a book I couldn’t put down. Sylvia is a true inspiration.” — Jeanne Cooper, star of <i>The Young and the Restless</i></p><p>Reaching deep beneath the surface of her life—then and now—renowned psychic and #1 <i>New York Times</i> bestselling author Sylvia Browne (<i>The Other Side and Back</i>) candidly discusses details of her professional and personal experiences that she’s never publically revealed before.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sylvia Browne
      </h2>
      
      <p class="authorDescription body article"><P>Sylvia Browne (October 19, 1936 &#8211; November 20, 2013) was a #1 <I>New York Times</I> bestselling author and world-famous psychic who appeared regularly on the <I>Montel Williams Show</I> and on <I>Larry King Live</I>, as well as making countless other media and public appearances. She also founded the Society of Novus Spiritus church, which celebrated its 25th anniversary in 2011.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?62598650